module.exports = __webpack_public_path__ + "static/media/media.657988d5.svg";